import { api } from "constants/RotasAPI";
import useFetch from "hooks/useFetch";
import { toast } from "react-hot-toast";
import { InformacoesUnidadeGestaoCobrancaDTO } from "types/dto/InformacoesUnidadeGestaoCobrancaDTO";
import { RequestInformacoesUnidade } from "types/request/RequestInfomacoesUnidade";

export const useGetInformacoesUnidade = (request: RequestInformacoesUnidade) => {
  const onError = () => {
    toast.error("Erro ao buscar informações da unidade.");
  };

  return useFetch<InformacoesUnidadeGestaoCobrancaDTO>({
    key: ["informacao-unidade", request.unidadeId],
    url: api.gestaoCobranca.getInformacoesUnidade,
    params: request,
    enabled: request.unidadeId !== undefined,
    onError,
  });
};
